import { Notification } from '@components';
import { Divider, StopsCard } from '@atgfr8/atg-ui-tailwind';
import { LastUsedTopStopModel } from '@typeDefinitions/stopTypes';

import { stopsListClasses } from './classes';

interface StopListProps {
  heading: string;
  stops: LastUsedTopStopModel[];
  setAddressFromStopList: (stop: LastUsedTopStopModel) => void;
  customerId: number | null;
}

export const StopsList = (props: StopListProps) => {
  return (
    <div class={stopsListClasses.container}>
      <div class="text-[#1B4960] phone:text-sm 1080p:text-lg font-semibold mb-2 flex">
        {props.heading}
      </div>
      {Boolean(props.customerId) ? (
        <div class={stopsListClasses.overflowContaier}>
          {props.stops.slice(0, 10).map((stop) => (
            <>
              <StopsCard
                stop={stop}
                stopCardClick={() => {
                  props.setAddressFromStopList(stop);
                }}
              />
              <Divider />
            </>
          ))}
        </div>
      ) : (
        <Notification
          type="warning"
          text="Please select a customer for the order to view stops."
        />
      )}
    </div>
  );
};
